/**
Project: Voice Panel (c)
Title: Main Route  
Description: Component for hadling the routes of the application
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { Provider, teamsTheme } from "@fluentui/react-northstar";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import BlankLayout from "../layout/blank-layout";
import FullLayout from "../layout/full-layout";
import PrivateRoute from "./private-route";
import AzureInsightsProvider from "../../core/components/azure-insights";
import { HelmetProvider } from "react-helmet-async";
import ErrorBoundary from "../../core/views/error-boundary";
import WhiteListDomain from "../../core/components/whitelist-domain";

class MainRoute extends Component {
  render() {
    return (
      <Provider theme={teamsTheme}>
        <BrowserRouter basename="/">
          <WhiteListDomain>
            <AzureInsightsProvider>
              <HelmetProvider>
                <ErrorBoundary>
                  <Switch>
                    <Route path="/signin" component={BlankLayout} />
                    <Route path="/signin-silent-start" component={BlankLayout} />
                    <Route path="/signin-silent-end" component={BlankLayout} />
                    <Route path="/signin-interactive-end" component={BlankLayout} />
                    <Route path="/signout-interactive" component={BlankLayout} />
                    <Route path="/signout" exact component={BlankLayout} />
                    <Route path="/error-frame" component={BlankLayout} />
                    <Route path="/error" component={BlankLayout} />
                    <Route path="/404" component={BlankLayout} />
                    <PrivateRoute path="/" component={FullLayout} />
                  </Switch>
                </ErrorBoundary>
              </HelmetProvider>
            </AzureInsightsProvider>
          </WhiteListDomain>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default MainRoute;
